module.exports = __webpack_public_path__ + "img/dangCommunity.aa009b76.png";